// WIP

import PropTypes from "prop-types"
import { css } from "styled-components"
import React from "react"
import { getLocalStorage } from "@karbonhq/marketing-shared-utils/utils/LocalStorage"
import { useLiveTemplatesData } from "../hooks/useLiveTemplateData"

export const DownloadCount = ({
  downloads = 0,
  contentfulId,
  size = "small",
}) => {
  const storeKey = contentfulId + "downloads"
  const liveData = useLiveTemplatesData()
  const localCount = parseInt(getLocalStorage(storeKey))

  let liveItem
  if (liveData.data) {
    liveItem = liveData.data.find(item => item.sys.id === contentfulId)
  }

  const liveCount = Math.max(
    liveItem?.fields?.downloads || 0,
    localCount || 0,
    downloads
  )

  if (liveCount < 10) {
    return null
  } else {
    return (
      <span
        css={css`
          font-size: ${size === "small" ? `14px` : `16px`};
          color: ${props => props.theme.colors.baseGrey};
        `}
      >
        {liveCount} Downloads
      </span>
    )
  }
}

DownloadCount.propTypes = {
  size: PropTypes.oneOf(["large", "small"]),
  downloads: PropTypes.number,
  contentfulId: PropTypes.string.isRequired,
}
